import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const createHsnCode = async (payload) => {
  return await axiosInstance.post("product/hsn-code", payload, { headers });
};

export const fetchHsnCodes = async () => {
  return await axiosInstance.get("product/hsn-code", { headers });
};

export const fetchHsnCodeDropdowns = async () => {
  const response = await axiosInstance.get("product/hsn-code/dropdown", {
    headers,
  });
  return response.data;
};

export const deleteHsnCode = async (groupId) => {
  return await axiosInstance.delete(`product/hsn-code/${groupId}`, { headers });
};

export const updateHsnCode = async (payload) => {
  return await axiosInstance.put("product/hsn-code", payload, { headers });
};

export const fetchHsnCodebyId = async (id) => {
  const response = await axiosInstance.get(`product/hsn-code/${id}`, {
    headers,
  });
  return response.data;
};
